import {
    Col,
    Row,
} from 'reactstrap';

import FreightTimeline from './FreightTimeline';
import Notes from './Notes';
import RecentDocuments from './RecentDocuments';
import RouteShipmentDetails from './RouteShipmentDetails';
import VerificationOverview from './VerificationOverview';

const Overview = ({
    freight,
}) => {
    return (
        <Row>
            <Col xl="7">
                <RouteShipmentDetails freight={freight} />
            </Col>

            <Col xl="5">
                <VerificationOverview overview={freight.verificationOverview} />
                <FreightTimeline items={freight.timeline} />
                <RecentDocuments documents={freight.documents} />
                <Notes notes={freight.notes} />
            </Col>
        </Row>
    );
};

export default Overview;
